import { render, staticRenderFns } from "./treeTransfer.vue?vue&type=template&id=661c32e6&scoped=true"
import script from "./treeTransfer.vue?vue&type=script&lang=js"
export * from "./treeTransfer.vue?vue&type=script&lang=js"
import style0 from "./treeTransfer.vue?vue&type=style&index=0&id=661c32e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c32e6",
  null
  
)

export default component.exports